import { SalablePricingTable } from './salable.js';

window.SalablePricingTable = SalablePricingTable;

export { SalablePricingTable };
